import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { index: String };

  connect() {
    // Delay initialization to ensure all controllers are connected
    setTimeout(() => {
      this.initializeAllStates();
    }, 100);
  }

  initializeAllStates() {
    // Only run this once from the first controller
    const allControllers = document.querySelectorAll(
      '[data-controller*="typus-selection"]',
    );
    if (allControllers[0] === this.element) {
      this.updateAllVisualStates();
    }
  }

  async toggle(event) {
    const checkbox = event.target;
    const index = this.indexValue;

    // First, clear all other selections
    this.clearOtherSelections();

    // Then update visual state for all elements
    this.updateAllVisualStates();

    // Save the selection to the server
    if (checkbox.checked) {
      await this.saveSelection(index);
    }
  }

  async saveSelection(selectedIndex) {
    try {
      const personId = this.getPersonId();
      const response = await fetch(`/people/${personId}/update_preferences`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.getCSRFToken(),
          Accept: 'application/json',
        },
        body: JSON.stringify({
          person: {
            selected_typus_index: selectedIndex,
          },
        }),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      await response.json();
      this.showFeedback('success', this.getTranslation('selection_saved'));
      window.location.reload();
    } catch {
      this.showFeedback('error', this.getTranslation('save_error'));
      this.revertSelection();
    }
  }

  getPersonId() {
    const container = document.querySelector('[data-person-id]');
    return container?.dataset.personId;
  }

  getCSRFToken() {
    const token = document.querySelector('meta[name="csrf-token"]');
    return token?.getAttribute('content');
  }

  getTranslation(key) {
    // Get translations from the container data attributes
    const container = document.querySelector('[data-person-id]');
    const translations = {
      selection_saved:
        container?.dataset.translationSelectionSaved || 'Selection saved',
      save_error:
        container?.dataset.translationSaveError || 'Error saving selection',
    };
    return translations[key];
  }

  showFeedback(type, message) {
    // Create a temporary notification
    const notification = document.createElement('div');
    notification.className = `fixed top-4 right-4 px-4 py-2 rounded-lg text-white z-50 ${
      type === 'success' ? 'bg-green-500' : 'bg-red-500'
    }`;
    notification.textContent = message;
    document.body.appendChild(notification);

    // Remove after 3 seconds
    setTimeout(() => {
      notification.remove();
    }, 3000);
  }

  revertSelection() {
    // Revert the checkbox state on save error
    this.element.checked = false;
    this.updateAllVisualStates();
  }

  clearOtherSelections() {
    // Find all checkboxes with same name and uncheck others
    const allCheckboxes = document.querySelectorAll(
      'input[name="selected_typus_item"]',
    );
    allCheckboxes.forEach((checkbox) => {
      if (checkbox !== this.element) {
        checkbox.checked = false;
      }
    });
  }

  updateAllVisualStates() {
    // Update visual state for all checkboxes
    const allCheckboxes = document.querySelectorAll(
      'input[name="selected_typus_item"]',
    );
    allCheckboxes.forEach((checkbox) => {
      const index = checkbox.value;
      this.updateVisualStateForIndex(index, checkbox.checked);
    });
  }

  updateVisualState() {
    // Update visual state for this specific checkbox
    const checkbox = this.element;
    const index = this.indexValue;
    this.updateVisualStateForIndex(index, checkbox.checked);
  }

  updateVisualStateForIndex(index, isChecked) {
    // Update checkmark
    const checkmark = document.querySelector(`[data-checkmark="${index}"]`);
    if (checkmark) {
      checkmark.style.display = isChecked ? 'block' : 'none';
    }

    // Update container border and background
    const container = document.querySelector(
      `[data-selection-container="${index}"]`,
    );
    if (container) {
      if (isChecked) {
        container.classList.remove('border-transparent');
        container.classList.add('border-gold-dark', 'bg-gold', 'bg-opacity-10');
      } else {
        container.classList.add('border-transparent');
        container.classList.remove(
          'border-gold-dark',
          'bg-gold',
          'bg-opacity-10',
        );
      }
    }
  }
}
